import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Custom404 from "@components/core/Custom404";

const Page404 = () => <Custom404 />;

export async function getStaticProps({ locale }) {
  return {
    props: {
      headerBehaviors: { noFooter: true },
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}

Page404.requireAuth = false;

export default Page404;
